var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 106.029,
    viewBox: "0 0 106 106.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 106,
    height: 106.029,
    fill: "#fff",
    stroke: "#c5c5c5",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M106,49.9v6.212c-.064.366-.137.731-.191,1.1-.331,2.282-.521,4.6-1.01,6.843A51.5,51.5,0,0,1,85.127,95.069c-12.9,9.772-27.424,13.012-43.262,9.71A51.168,51.168,0,0,1,11,85.241,51.551,51.551,0,0,1,.273,47.7,51.214,51.214,0,0,1,13.2,18.07,52.04,52.04,0,0,1,43.861.825C45.856.47,47.879.271,49.888,0H56.1a5.7,5.7,0,0,0,.8.17A50.445,50.445,0,0,1,80.025,7.464c13.732,8.416,22.183,20.549,25.15,36.422.371,1.987.555,4.008.825,6.014M39.743,53c0,6.383.009,12.765-.009,19.148,0,1.09.118,2.087,1.189,2.662a2.568,2.568,0,0,0,2.793-.43q14.913-9.6,29.837-19.187c2.056-1.323,2.061-3.048.009-4.367Q58.6,41.2,43.639,31.582a2.336,2.336,0,0,0-3.9,2.167c.017,6.417.009,12.834.009,19.251",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#c5c5c5",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.75eb29bc731591803e17d408e76d8bdf.svg";
export { ForwardRef as ReactComponent };